import localStorage from '@/services/localStorage'
import xhr from "@/services/xhr";

export default {
    name: "katu",
    data() {
        return {
            user: null,
            darkMode: false,
            menu: false,
            loading: false
        }
    },
    mounted() {
        this.darkMode = !!localStorage.get('darkMode');
        this.menu = localStorage.get('menu');
        this.user = localStorage.getSession();
        this.$root.$on('updateTheme', this.switchTheme)
        this.$root.$on('display-loading', (loading) => this.loading = loading)
    },
    computed: {
        routeName: function () {
            return this.$route? this.$route.name : ''
        }
    },
    methods: {
        switchTheme: function() {
            this.darkMode = !this.darkMode;
            localStorage.set('darkMode', this.darkMode)
        },
        switchMenu: function() {
            this.menu = !this.menu;
            localStorage.set('menu', this.menu)
        },
        logout: async function() {
            try {
                this.$root.$emit('display-loading', true)
                xhr('DELETE', '/api/security/logout', {}, true).then( () => {
                    localStorage.remove('session')
                }).catch( error => {
                    console.error("Error logging out >>", error)
                    localStorage.remove('session')
                }).finally(async () => {
                    this.$root.$emit('display-loading', false)
                    await this.$router.push('/security/login')
                })
            } catch (error) {
                console.error(error)
            }
        }
    }
}